import { gql } from '@apollo/client';

export const GET_TAGS = gql`
  query GetTags {
    tags {
      id
      name
      slug
      color
      description
      positionCount
      stockPositionCount
      createdAt
      updatedAt
    }
  }
`;
